<template lang="pug">
div(:class="$vuetify.breakpoint.mobile ? '' : 'pa-8'")
  .mb-6.d-flex.align-center(v-if="!$vuetify.breakpoint.mobile")
    .text-3xl.font-semibold Today
    v-spacer
    company-dropdown(v-if="isHq")
  .mb-4.d-flex.align-center(v-else)
    company-dropdown(v-if="isHq")

  sales-section(isToday)
  appointment-section(isToday)
  in-clinic-section(isToday)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SalesSection from './SalesSection.vue'
import AppointmentSection from './AppointmentSection.vue'
import InClinicSection from './InClinicSection.vue'
import CompanyDropdown from '@/components/hq/custom/CompanyDropdown.vue'

export default {
  name: 'InsightToday',
  components: { SalesSection, AppointmentSection, InClinicSection, CompanyDropdown },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq'
    })
  },
  methods: {
    ...mapActions(['showMessage']),
  }
}
</script>